export interface Capability {
  title: string;
  overline: string;
  description: string;
  bulletPoints: string[];
  buyerValue?: string;
  image: string;
}

export const CAPABILITIES: Capability[] = [
  {
    overline: "INDUSTRIAL SUPPLY",
    title: "Industrial Supply Capability",
    description:
      "Sky Mark Co. supports clients with industrial materials and project-related products required for electrical, mechanical, civil, and general industrial scopes. Our supply support is suitable for contractors, infrastructure teams, industrial users, and procurement departments looking for practical sourcing assistance.",
    bulletPoints: [
      "Project material requirements",
      "Industrial accessories",
      "Construction-related items",
      "Electrical installation materials",
      "Mechanical support items",
      "Civil project materials",
      "BOQ-based inquiries",
      "Urgent project materials",
      "Replacement and support items",
    ],
    image: "/images/electrical-supply.jpg",
  },
  {
    overline: "CNC LASER CUTTING",
    title: "CNC Laser Cutting Capability",
    description:
      "CNC laser cutting is used to cut steel sheets into accurate flat components. It is suitable for producing plates, brackets, gussets, rails, strips, covers, guards, and custom-shaped parts.",
    bulletPoints: [
      "Mounting plates",
      "Base plates",
      "Adapter plates",
      "Spacer plates",
      "Shim plates",
      "Gusset plates",
      "Stiffeners",
      "Slotted rails",
      "Flat brackets",
      "Protective covers",
      "Custom laser-cut parts",
    ],
    buyerValue:
      "Laser cutting helps produce repeatable parts with clean edges, accurate holes, and consistent dimensions. This reduces rework during fabrication and installation.",
    image: "/images/cnc-laser-cutting.jpg",
  },
  {
    overline: "PRESS BRAKE BENDING",
    title: "Press Brake Bending Capability",
    description:
      "Press brake bending converts flat metal sheets into formed shapes. It is used to manufacture brackets, channels, profiles, covers, enclosures, support items, and folded parts.",
    bulletPoints: [
      "L brackets",
      "U brackets",
      "Z brackets",
      "C profiles",
      "U channels",
      "Hat channels",
      "Formed covers",
      "Equipment hoods",
      "Small enclosures",
      "Folded supports",
    ],
    buyerValue:
      "Bending adds strength and shape to flat steel parts, allowing them to become functional support components.",
    image: "/images/press-brake-bending.jpg",
  },
  {
    overline: "TUBE & PIPE FABRICATION",
    title: "Tube & Pipe Fabrication Capability",
    description:
      "Tube and pipe fabrication supports the production of round and square tube-based items. These are used in poles, stands, frames, safety barriers, wall arms, and support assemblies.",
    bulletPoints: [
      "Instrument stands",
      "Lighting poles",
      "CCTV poles",
      "Equipment poles",
      "Wall arms",
      "Handrails",
      "Guardrails",
      "Bollards",
      "Barriers",
      "Tube frames",
    ],
    buyerValue:
      "Tube fabrication helps create strong, practical support items that are commonly required in infrastructure and industrial projects.",
    image: "/images/tube-fabrication.jpg",
  },
  {
    overline: "WELDING & HEAVY FABRICATION",
    title: "Welding & Heavy Fabrication Capability",
    description:
      "Steel fabrication involves cutting, bending, welding, assembly, and finishing to create larger steel structures and project-specific items.",
    bulletPoints: [
      "Equipment skids",
      "Structural frames",
      "Platforms",
      "Walkways",
      "Stairs",
      "Ladders",
      "Racks",
      "Storage structures",
      "Panel stands",
      "Custom welded assemblies",
    ],
    buyerValue:
      "Heavy fabrication allows multiple steel components to be combined into complete assemblies ready for installation, equipment mounting, or project use.",
    image: "/images/welding-fabrication.jpg",
  },
  {
    overline: "POWDER COATING",
    title: "Powder Coating Capability",
    description:
      "Powder coating provides a durable and clean surface finish for steel and metal components. It improves appearance and provides surface protection for parts used in project and industrial environments.",
    bulletPoints: [
      "Fabricated steel items",
      "Brackets and supports",
      "Frames and accessories",
      "Panels and covers",
      "Industrial components",
      "Custom fabricated items",
    ],
    image: "/images/powder-coating.jpg",
  },
  {
    overline: "EPOXY COATING",
    title: "Epoxy Coating Capability",
    description:
      "Epoxy coating provides enhanced protective surface treatment for components exposed to demanding conditions. It is suitable for project-related items where durability, resistance, and surface protection are important.",
    bulletPoints: [
      "Industrial components",
      "Steel items requiring added protection",
      "Project-specific coated materials",
      "Items exposed to harsher working conditions",
      "Fabricated parts requiring protective coating",
    ],
    image: "/images/epoxy-coating.jpg",
  },
  {
    overline: "PROJECT SUPPORT",
    title: "Project Support Capability",
    description:
      "Many project requirements are not standard catalog items. Sky Mark Co. supports clients by reviewing BOQs, drawings, sketches, and material lists to coordinate the correct supply, fabrication, or coating solution.",
    bulletPoints: [
      "Quotation requests",
      "Material inquiry review",
      "Drawing-based fabrication inquiry",
      "BOQ-based supply support",
      "Coating requirement coordination",
      "Direct communication with project teams",
      "Project packaging and delivery coordination",
    ],
    image: "/images/project-support.jpg",
  },
];

export const PROCESS_STEPS = [
  {
    number: "01",
    title: "Share Your Requirement",
    description:
      "Send BOQ, drawings, sketches, material list, or inquiry details.",
  },
  {
    number: "02",
    title: "Review & Clarification",
    description:
      "Our team reviews the scope, required material, finish, quantity, and timeline.",
  },
  {
    number: "03",
    title: "Quotation & Coordination",
    description:
      "We prepare the offer and coordinate supply, fabrication, coating, or delivery details.",
  },
  {
    number: "04",
    title: "Production / Supply Support",
    description:
      "We support cutting, bending, fabrication, coating, sourcing, and material coordination.",
  },
  {
    number: "05",
    title: "Inspection & Delivery",
    description:
      "Items are checked, organized, packed, and delivered according to project needs.",
  },
];

export const WHY_CHOOSE_POINTS = [
  "Local presence in Riyadh",
  "Direct contact with responsible team",
  "Broad industrial supply and fabrication scope",
  "Support for infrastructure and project-based requirements",
  "Ability to work from BOQs, drawings, sketches, and material lists",
  "Fabrication and coating capability under one company",
  "Fast communication by phone, email, and WhatsApp",
  "Clear working hours and accessible location",
];
